import React, { useEffect, useState, useRef, useCallback } from 'react'
import './NewCollection.css'
import Item from '../Item/Item'


// const ITEM_WIDTH = 266   // matches .item width in Item.css
const ITEM_GAP = 30    // matches gap in .new-items
// const STEP = ITEM_WIDTH + ITEM_GAP   // scroll exactly one item per click

const NewCollection = () => {

    const [new_collection, setNew_collection] = useState([]);

    const [canScrollLeft,  setCanScrollLeft]  = useState(false)
    const [canScrollRight, setCanScrollRight] = useState(true)

    const carouselRef = useRef(null);

    useEffect(()=>{
        fetch(`${process.env.REACT_APP_API_URL}/new-collection`)
        .then((response) => response.json())
        .then((data) => setNew_collection(data));
    },[])


    //for carousal width and step
    const getStep = useCallback(() => {
        const firstItem = carouselRef.current?.querySelector('.item')
        if (!firstItem) return 270   // fallback
        return firstItem.offsetWidth + ITEM_GAP
    }, [])
    
    const updateArrows = useCallback(() => {
        const el = carouselRef.current
        if (!el) return
        setCanScrollLeft(el.scrollLeft > 4)
        setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 4)
    }, [])

    useEffect(() => {
        const el = carouselRef.current
        if (!el) return
        updateArrows()
        el.addEventListener('scroll', updateArrows, { passive: true })
        return () => el.removeEventListener('scroll', updateArrows)
    }, [new_collection, updateArrows])

    const scrollLeft = () => {
        carouselRef.current?.scrollBy({ left: -getStep(), behavior: 'smooth' })
    }
    
    const scrollRight = () => {
        carouselRef.current?.scrollBy({ left: getStep(), behavior: 'smooth' })
    }

    return (
        <div className='new-collection'>
            <h2>New Collection</h2>

            <div className="nc-carousel-wrapper">
                <button className={`nc-carousel-btn left ${!canScrollLeft ? 'nc-carousel-btn--hidden' : ''}`} onClick={scrollLeft} aria-label="Previous">&#10094;</button>
                
                <div className="nc-new-items" ref={carouselRef}>
                    {new_collection.map((item, index) => {
                        return <Item key={index} id={item.id} name={item.name} discount_percentage={item.discount_percentage} available={item.available} image={item.images[0]} price={item.price} old_price={item.old_price}/>
                    })}
                </div>

                <button className={`nc-carousel-btn right ${!canScrollRight ? 'nc-carousel-btn--hidden' : ''}`} onClick={scrollRight} aria-label="Next">&#10095;</button>
            </div>
            
        </div>
    )
}

export default NewCollection